import { createTask, createFilters } from "./helpers";
import { DEFAULT_FILTERS } from "../constants";

export const adaptEditedCreatedTask = (task) => createTask(task);

export const adaptPostPutTask = (payload) => ({
  id: payload.id,
  uuid: payload.uuid,
  name: payload.name,
  instructions: payload.instructions,
  note: payload.note,
  priority: payload.priority,
  externally_visible: payload.externally_visible,
  type: payload.type,
  appointment_type: payload.appointment_type,
  location: payload.location,
  outcome: payload.outcome,
  due_on: payload.due_on || undefined,
  assigned_to_user_id: payload.assigned_to_user_id,
  completed_by_user_id: payload.completed_by_user_id,
  recurring: !!payload.recurring,
  completed: payload.completed,
  recurring_frequency: payload.recurring_frequency,
  recurring_every_so_many_days: payload.recurring_every_so_many_days,
  recurring_day_of_week: payload.recurring_day_of_week,
  run: payload.run,
  contingent: !!payload.contingent,
  contingency_rule: payload.contingency_rule,
});

export const adaptGetAllTasks = (tasks = []) => tasks.map((task) => createTask(task));

export const adaptTitle = ({ title }) => ({
  title,
});

export const adaptTeam = (team) =>
  team.map(({ name: label, uuid: value }) => ({ label, value })).sort((a, b) => a - b);

export const adaptFilterPayload = (tasks) => {
  const filters = {
    ...DEFAULT_FILTERS,
  };

  return createFilters(filters, tasks);
};

export const adaptPutBulkEditTask = (listingUuid, selectedTasks, payload) => ({
  uuid: listingUuid,
  tasks: selectedTasks.map((id) => ({ ...payload, id })),
  authenticity_token: window.ReactOnRails.authenticityToken(),
});
